import { ApiBlueprint, createFrontendPlugin, discoveryApiRef, fetchApiRef, PageBlueprint } from '@backstage/frontend-plugin-api';
import { nvdApiRef, NvdClient } from './api';
import { nvdRouteRef } from './routes';
import SecurityIcon from '@material-ui/icons/Security';

const nvdApi = ApiBlueprint.make({
  params: defineParams => 
    defineParams({
      api: nvdApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new NvdClient({ fetchApi, discoveryApi }),
    }),
});

const cveIndexPage = PageBlueprint.make({
  params: {
    path: '/nvd',
    title: 'Vulnerabilities',
    icon: <SecurityIcon />,
    routeRef: nvdRouteRef,
    loader: () =>
      import('./components/CveIndexPage').then(m => <m.CveIndexPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'nvd',
  extensions: [
    nvdApi,
    cveIndexPage,
  ],
  routes: {
    root: nvdRouteRef,
  },
});